import { Injectable } from '@angular/core';
import { APP_ROUTES } from '@app/app.routes';
import { EERROR_BUTTON_EVENT } from '@app/core/models/error.model';
import { UtilService } from '@app/services/util.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';
import { ErrorService } from '../../../core/services/error.service';
import * as errorActions from './error.actions';

@Injectable()
export class ErrorEffects {
  constructor(
    private actions$: Actions,
    private _errorService: ErrorService,
    public _utilService: UtilService
  ) {}

  handleError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(errorActions.handleError),
        tap((data) => {
          this._errorService.handleError(
            data.message,
            data.errorType,
            data.isCustomer,
            data.callback,
            data.componentData
          );
        })
      ),
    { dispatch: false }
  );

  showError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(errorActions.showError),
        tap((data) => {
          this._errorService.showError(
            data.message,
            data.errorType,
            data.isCustomer,
            data.callback,
            data.componentData
          );
        })
      ),
    { dispatch: false }
  );

  showErrorComponent$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(errorActions.showErrorComponent),
        tap((data) => {
          const route: string = APP_ROUTES.ERRORS;
          return this._utilService.navigateTo(route);
        })
      ),
    { dispatch: false }
  );

  controlErrorButtonEvent$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(errorActions.controlErrorButtonEvent),
        tap(({ buttonEvent }: { buttonEvent: EERROR_BUTTON_EVENT }) => {
          this._errorService.handleErrorButtonEvent(buttonEvent);
        })
      ),
    { dispatch: false }
  );
}
